export const getChartTitle = (spec: string): string | undefined => {
  try {
    const parsed = JSON.parse(spec) as { title?: unknown };
    const title = parsed.title;
    if (typeof title === 'string') return title.trim() || undefined;
    if (title && typeof title === 'object') {
      const text = (title as { text?: unknown }).text;
      return typeof text === 'string' ? text.trim() || undefined : undefined;
    }
  } catch {
    return undefined;
  }
  return undefined;
};
